import React from 'react';
import { Section, SkeletonItem } from '@atlaskit/side-navigation';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import { withThrowOnError } from '@atlassian/jira-navigation-apps-sidebar-common/src/utils/throw-when-no-data-and-error/index.tsx';
import { isDevopsFeatureDisabledInFedRamp } from '@atlassian/jira-software-devops-fedramp-utils/src/index.tsx';
import { messages } from './messages.tsx';
import {
	shouldCycleTimeReportRendered,
	shouldDeploymentFrequencyReportRendered,
	useDevOpsReportPreconditionResourceAutoRefetch,
} from './utils.tsx';

export const DevOpsReports = () => {
	const { formatMessage } = useIntl();
	const devOpsReportGroupPrecondition = useDevOpsReportPreconditionResourceAutoRefetch();
	const { data: project } = withThrowOnError(useProject)();

	if (project == null || devOpsReportGroupPrecondition == null) {
		return (
			<>
				<SkeletonItem />
				<SkeletonItem />
			</>
		);
	}
	const renderCycleTimeReport = shouldCycleTimeReportRendered(devOpsReportGroupPrecondition);
	const renderDeploymentFrequencyReport = shouldDeploymentFrequencyReportRendered(
		devOpsReportGroupPrecondition,
	);

	if (
		isDevopsFeatureDisabledInFedRamp() ||
		(!renderCycleTimeReport && !renderDeploymentFrequencyReport)
	) {
		return null;
	}

	return (
		<Section title={formatMessage(messages.devOps)}>
			{renderCycleTimeReport && (
				<MenuItem
					analytics={{ itemId: 'cycleTimeReport' }}
					selectedOn={['software-reports-cycle-time-classic']}
					href={`/jira/software/c/projects/${project.key}/reports/cycle-time`}
				>
					{formatMessage(messages.cycleTime)}
				</MenuItem>
			)}
			{renderDeploymentFrequencyReport && (
				<MenuItem
					analytics={{ itemId: 'deploymentFrequencyReport' }}
					selectedOn={['software-reports-deployment-frequency-classic']}
					href={`/jira/software/c/projects/${project.key}/reports/deployment-frequency`}
				>
					{formatMessage(messages.deploymentFrequency)}
				</MenuItem>
			)}
		</Section>
	);
};

export default DevOpsReports;
